import { createContext, useContext } from 'react';

export const ChainsContext = createContext([]);

export const useChains = () => useContext(ChainsContext);